import { createSlice } from '@reduxjs/toolkit'
import { RootState } from '../store'
import { ApiStatus } from '../../types/api/status'
import { priceListBranchoffice, priceListBranchofficeType } from '../../types/slices/priceListBranchofficeType'

const initialState: priceListBranchofficeType =
{
    status: ApiStatus.FETCHED,
    priceListBranch: [],
    priceListSelectedBranch: {} as priceListBranchoffice,
    errorMessage: undefined,
    action: ''
}

const priceListBranchofficeSlice = createSlice({
    name: 'priceListBranchofficeSlice',
    initialState,
    reducers: {
        onFetchPriceListBranch (state, { payload }: { payload: priceListBranchoffice[]}) {
            state.status = ApiStatus.FETCHED
            state.priceListBranch = payload
            state.errorMessage = undefined
        },
        onSetSelectedPriceListBranch (state, { payload }: { payload: priceListBranchoffice }) {
            state.priceListSelectedBranch = payload
        },
        changeStatus (state, { payload }: { payload: ApiStatus}){
            state.status = payload
        },
        setAction (state, { payload }: { payload: string }) {
            state.action = payload
        },
    }
})

export const selectPriceListBranchState = (state: RootState) => state.priceListBranchofficeSlice
export default priceListBranchofficeSlice.reducer
export const {
    onFetchPriceListBranch,
    onSetSelectedPriceListBranch,
    changeStatus,
    setAction,
} = priceListBranchofficeSlice.actions
